import React from "react";
import "@/animations/animate.css";

import Image from "next/image";
import AnimatedElements from "@/animations/AnimatedElement";
import { motion, useScroll, useSpring, useTransform } from 'framer-motion';
import AnimatedBody from "@/animations/AnimatedBody";
import AnimatedLetters from "@/animations/AnimatedLetters";
import { Ivy } from "@/fonts/spaceGrotesk";
import zodiacImage from '../../public/zodiac-min.png'
const Zoadiac = ({certificate }: any ) => {
    const ref = React.useRef(null)
    const { scrollYProgress } = useScroll({
        target: ref,
        offset: ["start end", "100vh"]
    
    })
  
    const transform = useTransform(
      scrollYProgress,
      [0, 1],
      [0,90]
    )
  
    const [result, setResult] = React.useState<any>(null);
        const [load , setLoad] = React.useState(false);
    
        React.useEffect(() => {
        
            async function getdata() {
           
                
                const zodiac = await fetch(`${process.env.NEXT_PUBLIC_URL}/api/zodiac?certificate=${certificate}`);
                const zodiac2 = await zodiac.json();
                console.log(zodiac2)
                setLoad(true)
                setResult(zodiac2)
            }
        
            getdata();
        
        }
        , [])
  
    const physics = { damping: 15, mass: 0.27, stiffness: 55 }
    const rotateZ = useSpring(transform, physics)

    return (
        <>

        <section
            ref={ref}
            className="relative min-h-screen z-10 0 w-screen  items-center justify-center overflow-hidden bg-black bg-cover bg-center pt-16 pb-36 md:pt-20 md:pb-44 lg:pt-20 lg:pb-56"
            id="Zoadiac"
        >
           




            <div className="mx-auto flex w-full flex-col sm:flex-row items-center justify-center">
            <div className=" flex w-screen  flex-col  items-center justify-center  text-[18px] font-medium  leading-relaxed tracking-wide text-[#e4ded7]  md:text-[20px] md:leading-relaxed  lg:text-[24px] ">
                 <motion.div 
                 style={
                    {
                        rotateZ
                    }
                 }
                 >   <AnimatedElements>   
                    <Image 
                    src={zodiacImage}
                    alt="Picture of the author"
                    className="rounded-3xl "
                        width={500}
                        height={500}
                        />
                                           <div className="w-80 h-80 rounded-full bg-opacity-30 bg-yellow-500 blur-3xl absolute top-0 bottom-0 left-0 right-0 mx-auto my-auto"></div>

                      </AnimatedElements>     
                      </motion.div>
                    </div>
            <div className="mx-auto flex w-screen flex-col items-center gap-1.5   ">
           
            {load && (<>
                <AnimatedLetters style={`font-black !overflow-visible items-center w-[100%] justify-center flex flex-col text-center m-0 ${Ivy.className}`}
                    title={`${result.symbol} `} /> <AnimatedLetters style={`font-black items-center w-[100%] justify-center flex flex-col text-center m-0 ${Ivy.className}`}
                    title={`${result.zodiacSignGloss} Burcu`} />


<AnimatedBody delay={0.2}
                    className="text-[1rem] mt-3 sm:text-[1.4rem] font-normal text-center !text-opacity-100 !text-white-vibrant "
                    text={`O günü temsil eden burç, ${result.zodiacSignGloss} burcuydu.

                    `} /></>

)}
                  
                </div>
               
            </div>
        </section></>
    );
};

export default Zoadiac;
